export default "/images/header-small@2x.png?23223a7fa4fbebea01569190ee2e1bc5";